import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Footer } from "../../Components/Footer";

import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import { useParams } from "react-router-dom";
import { getBadges } from "../../Slices/badges";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import axios from "axios";
import ValidateBadge from "../../Components/validateBadge";
import moment from "moment";

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LinkZoneWithCopyButton from "../../Components/CopyLinkButton";

import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import { app, sharing } from "@microsoft/teams-js";



export default function SingleBadge() {
  useDocumentTitle("Odznaka");

  const { badgeId } = useParams();
  const dispatch = useDispatch();

  const { user, accessToken: jwt } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);

  const teamsShareRef = useRef(null);

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (user?.email && jwt) {
      dispatch(
        getBadges({
          email: user.email,
          user: user.jwt,
        })
      );
    }
  }, [dispatch, user?.email, user?.jwt]);

  const selectBadge = createSelector(
    (state) => state.badges,
    (badges) =>
      badges.filter(
        (badge) => badge.id === Number(badgeId)
      )[0]
  );

  const badge = useSelector(selectBadge);

  console.log("badge", badge);

  const CutText = (text, maxWords) => {
    if (!text) return "";

    const words = text.split(" ");

    if (words.length <= maxWords) {
      return text;
    }

    return words.slice(0, maxWords).join(" ") + "...";
  };


  useEffect(() => {
    if (!badge || !teamsShareRef.current) return;

    const badgeUrl = `${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`;

    const renderTeamsButton = () => {
      if (
        window.shareToMicrosoftTeams &&
        teamsShareRef.current
      ) {
        teamsShareRef.current.setAttribute(
          "data-href",
          badgeUrl
        );

        teamsShareRef.current.setAttribute(
          "data-msg-text",
          `Zobacz moje mikropoświadczenie z tematu ${badge.attributes.badgeName} w Micree:` || "Micree"
        );

        teamsShareRef.current.setAttribute(
          "data-preview",
          "true"
        );

        window.shareToMicrosoftTeams.renderButtons({
          elements: [teamsShareRef.current],
        });
      }
    };

    if (window.shareToMicrosoftTeams) {
      renderTeamsButton();
      return;
    }

    const existingScript = document.querySelector(
      'script[src="https://teams.microsoft.com/share/launcher.js"]'
    );

    if (existingScript) {
      existingScript.addEventListener(
        "load",
        renderTeamsButton,
        { once: true }
      );

      return () => {
        existingScript.removeEventListener(
          "load",
          renderTeamsButton
        );
      };
    }

    const script = document.createElement("script");

    script.src =
      "https://teams.microsoft.com/share/launcher.js";

    script.async = true;
    script.defer = true;

    script.onload = renderTeamsButton;

    document.body.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, [badge]);

  if (!badge) {
    return (
      <>
        <Box
          sx={{
            minHeight: "70vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress aria-label="Loading…" />
          </Box>
        </Box>

        <Footer />
      </>
    );
  }

  const badgeImage =
    badge.attributes.image.data?.attributes?.url;

  const badgeSets =
    badge.attributes.badge_model_reference.data?.attributes
      ?.sets?.data || [];

  const learningEffects =
    badge.attributes.learningEffects?.learningEffects || [];


  const InfoRow = ({
    icon,
    label,
    children,
  }) => (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        py: 1.7,
        borderBottom: "1px solid",
        borderColor: "rgba(17, 51, 75, 0.08)",
        "&:last-child": {
          borderBottom: 0,
        },
      }}
    >
      <Box
        sx={{
          width: 42,
          height: 42,
          minWidth: 42,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(108, 198, 217, 0.13)",
          color: "#11334b",
        }}
      >
        {icon}
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "text.secondary",
            fontWeight: 600,
            mb: 0.3,
          }}
        >
          {label}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#11334b",
            fontWeight: 700,
            lineHeight: 1.4,
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          py: {
            xs: 3,
            md: 6,
          },
          // background:
          //   "linear-gradient(180deg, #f4f8fa 0%, #ffffff 55%, #f7fafb 100%)",
        }}
      >
        <Container maxWidth="lg">

          <Box
            sx={{
              textAlign: "center",
              mb: {
                xs: 3,
                md: 5,
              },
            }}
          >
            {/* <Chip
              icon={<VerifiedRoundedIcon />}
              label="Zweryfikowane mikropoświadczenie"
              sx={{
                mb: 2,
                px: 1,
                height: 34,
                borderRadius: "20px",
                fontWeight: 700,
                color: "#11334b",
                backgroundColor:
                  "rgba(108, 198, 217, 0.15)",
                "& .MuiChip-icon": {
                  color: "#16809a",
                },
              }}
            /> */}

            <Typography
              component="h1"
              sx={{
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  md: "3rem",
                },
                fontWeight: 800,
                letterSpacing: "-0.035em",
                lineHeight: 1.15,
                color: "#11334b",
              }}
            >
              {badge.attributes.badgeName}
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              overflow: "hidden",
              borderRadius: {
                xs: 3,
                md: 5,
              },
              border:
                "1px solid rgba(17, 51, 75, 0.08)",
              boxShadow:
                "0 25px 70px rgba(17, 51, 75, 0.10)",
              backgroundColor: "#ffffff",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  position: "relative",
                  minHeight: {
                    xs: 400,
                    md: 650,
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: {
                    xs: 4,
                    md: 6,
                  },
                  overflow: "hidden",
                  background: "#294e6b",
                }}
              >
                {[
                  {
                    top: "6%",
                    left: "7%",
                    size: 190,
                    rotate: "-12deg",
                  },
                  {
                    top: "6%",
                    right: "7%",
                    size: 190,
                    rotate: "12deg",
                  },
                  {
                    top: "38%",
                    left: "-5%",
                    size: 180,
                    rotate: "10deg",
                  },
                  {
                    top: "38%",
                    right: "-5%",
                    size: 180,
                    rotate: "-10deg",
                  },
                  {
                    bottom: "6%",
                    left: "7%",
                    size: 190,
                    rotate: "12deg",
                  },
                  {
                    bottom: "6%",
                    right: "7%",
                    size: 190,
                    rotate: "-12deg",
                  },
                  {
                    top: "20%",
                    left: "38%",
                    size: 155,
                    rotate: "8deg",
                  },
                  {
                    bottom: "18%",
                    right: "38%",
                    size: 155,
                    rotate: "-8deg",
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "absolute",
                      top: item.top,
                      bottom: item.bottom,
                      left: item.left,
                      right: item.right,

                      width: item.size,
                      height: item.size,

                      transform: `rotate(${item.rotate})`,

                      opacity: 0.22,
                      filter: "blur(1px)",

                      zIndex: 0,

                      "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      },
                    }}
                  >
                    <img
                      src={badgeImage}
                      alt=""
                    />
                  </Box>
                ))}

                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "radial-gradient(circle at center, rgba(41,78,107,0.35) 0%, rgba(41,78,107,0.72) 55%, rgba(41,78,107,0.96) 100%)",
                    zIndex: 1,
                  }}
                />

                <Box
                  sx={{
                    position: "relative",
                    zIndex: 3,
                    width: "100%",
                    maxWidth: 420,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={badgeImage}
                    alt="badge"
                    style={{
                      display: "block",
                      width: "100%",
                      height: "auto",
                      borderRadius: "18px",
                    }}
                  />
                </Box>
              </Grid>


              {/* <Grid
                item
                xs={12}
                md={5}
                sx={{
                  position: "relative",
                  minHeight: {
                    xs: 400,
                    md: 650,
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: {
                    xs: 4,
                    md: 6,
                  },
                  background:
                    "radial-gradient(circle at center, #294e6bad 0%, #294e6bd6 40%, #294e6b 70%), #294e6b54",
                }}
              >

                <Box
                  sx={{
                    position: "absolute",
                    width: {
                      xs: 280,
                      md: 420,
                    },
                    height: {
                      xs: 280,
                      md: 420,
                    },
                    borderRadius: "50%",
                    border:
                      "1px solid rgba(17,51,75,0.06)",
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    width: {
                      xs: 220,
                      md: 330,
                    },
                    height: {
                      xs: 220,
                      md: 330,
                    },
                    borderRadius: "50%",
                    border:
                      "1px solid rgba(17,51,75,0.06)",
                  }}
                />

                <Box
                  sx={{

                  }}
                >
                  <img
                    src={badgeImage}
                    alt="badge"
                    style={{
                      display: "block",
                      width: "100%",
                      height: "auto",
                      borderRadius: "18px",
                    }}
                  />


                </Box>
              </Grid> */}

              <Grid
                item
                xs={12}
                md={7}
                sx={{
                  p: {
                    xs: 3,
                    sm: 4,
                    md: 5,
                  },
                }}
              >

                <Box
                  sx={{
                    mb: 4,
                    p: 3,
                    borderRadius: 3,
                    background:
                      "linear-gradient(135deg, rgba(17,51,75,0.04), rgba(108,198,217,0.10))",
                  }}
                >
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: {
                        xs: "1.15rem",
                        md: "1.35rem",
                      },
                      lineHeight: 1.55,
                      color: "#11334b",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {badge.desc}
                    </span>
                  </Typography>
                </Box>

                <Typography
                  variant="overline"
                  sx={{
                    color: "#16809a",
                    fontWeight: 800,
                    letterSpacing: "0.12em",
                  }}
                >
                  INFORMACJE O ODZNACE
                </Typography>

                <Paper
                  elevation={0}
                  sx={{
                    mt: 1,
                    px: 2,
                    borderRadius: 3,
                    border:
                      "1px solid rgba(17,51,75,0.08)",
                  }}
                >
                  <InfoRow
                    icon={
                      <CalendarMonthRoundedIcon fontSize="small" />
                    }
                    label="Data wystawienia:"
                  >
                    {moment(
                      badge.attributes.issuanceDate
                    ).format("LL")}
                  </InfoRow>

                  <InfoRow
                    icon={
                      <SchoolRoundedIcon fontSize="small" />
                    }
                    label={`Data ${badge.attributes.szkolenie === true
                      ? "ukończenia szkolenia"
                      : "egzaminu"
                      }:`}
                  >
                    {badge.attributes.exam_expiry_date
                      ? moment(
                        badge.attributes.exam_expiry_date
                      ).format("LL")
                      : ""}
                  </InfoRow>

                  <InfoRow
                    icon={
                      <EventAvailableRoundedIcon fontSize="small" />
                    }
                    label="Data wygaśnięcia:"
                  >
                    {badge.attributes.expirationDate
                      ? moment(
                        badge.attributes.expirationDate
                      ).format("LL")
                      : "bezterminowo"}
                  </InfoRow>

                  <InfoRow
                    icon={
                      <BusinessRoundedIcon fontSize="small" />
                    }
                    label="Instytucja wystawiająca:"
                  >
                    <b>Fundacja VCC</b>{" "}
                    <span>
                      {badge.attributes.issuer}
                    </span>
                  </InfoRow>

                  <InfoRow
                    icon={
                      <PublicRoundedIcon fontSize="small" />
                    }
                    label="Kraj wystawcy:"
                  >
                    <b>Polska</b>{" "}
                    <span>
                      {badge.attributes.issuer}
                    </span>
                  </InfoRow>

                  <InfoRow
                    icon={
                      <WorkspacePremiumRoundedIcon fontSize="small" />
                    }
                    label="Rodzaj odznaki:"
                  >
                    {badge.attributes.badgeType}
                  </InfoRow>

                  {badge?.attributes?.qualificationName && (
                    <InfoRow
                      icon={
                        <FactCheckRoundedIcon fontSize="small" />
                      }
                      label="Kwalifikacja:"
                    >
                      {badge.attributes.qualificationName}
                    </InfoRow>
                  )}
                </Paper>


                <Box sx={{ mt: 5 }}>
                  <Typography
                    variant="overline"
                    sx={{
                      color: "#16809a",
                      fontWeight: 800,
                      letterSpacing: "0.12em",
                    }}
                  >
                    EFEKTY UCZENIA SIĘ:
                  </Typography>

                  <Paper
                    elevation={0}
                    sx={{
                      mt: 1,
                      p: 2,
                      borderRadius: 3,
                      backgroundColor: "#f8fafb",
                      border:
                        "1px solid rgba(17,51,75,0.08)",
                    }}
                  >
                    <List sx={{ p: 0 }}>
                      {learningEffects.map((item, i) => (
                        <ListItem
                          key={i}
                          sx={{
                            px: 1,
                            py: 1.2,
                            alignItems: "flex-start",
                            "&:not(:last-child)": {
                              borderBottom:
                                "1px solid rgba(17,51,75,0.06)",
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 32,
                              mt: 0.5,
                            }}
                          >
                            <ChevronRightIcon
                              sx={{
                                color: "#16809a",
                              }}
                            />
                          </ListItemIcon>

                          <ListItemText
                            primary={item.effectName}
                            primaryTypographyProps={{
                              fontSize: "0.95rem",
                              lineHeight: 1.55,
                              fontWeight: 500,
                              color: "#263238",
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Paper>
                </Box>


                <Box sx={{ mt: 4 }}>
                  <LinkZoneWithCopyButton
                    slug={badge.attributes.slug}
                  />
                </Box>


                <Stack
                  direction={{
                    xs: "column",
                    sm: "row",
                  }}
                  spacing={2}
                  sx={{
                    mt: 4,
                  }}
                >
                  <a
                    href={badgeImage}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                      flex: 1,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<DownloadRoundedIcon />}
                      sx={{
                        minHeight: 52,
                        borderRadius: "14px",
                        px: 3,
                        textTransform: "none",
                        fontWeight: 700,
                        color: "#11334b",
                        borderColor:
                          "rgba(17,51,75,0.18)",
                        backgroundColor:
                          "rgba(237,108,2,0.05)",
                        "&:hover": {
                          borderColor: "#11334b",
                          backgroundColor:
                            "rgba(237,108,2,0.10)",
                        },
                      }}
                    >
                      Pobierz mikropoświadczenie
                    </Button>
                  </a>

                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<VerifiedRoundedIcon />}
                    onClick={() => setShow(true)}
                    sx={{
                      flex: 1,
                      minHeight: 52,
                      borderRadius: "14px",
                      px: 3,
                      textTransform: "none",
                      fontWeight: 800,
                      background:
                        "linear-gradient(135deg, #11334b, #16809a)",
                      boxShadow:
                        "0 8px 20px rgba(17,51,75,0.18)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #0d2b3e, #116f85)",
                        boxShadow:
                          "0 12px 28px rgba(17,51,75,0.24)",
                      },
                    }}
                  >
                    Weryfikuj
                  </Button>
                </Stack>


                <Modal
                  open={show}
                  onClose={handleClose}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                  }}
                >
                  <ValidateBadge setShow={setShow} />
                </Modal>


                <Box
                  sx={{
                    mt: 4,
                    pt: 3,
                    borderTop:
                      "1px solid rgba(17,51,75,0.08)",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ mb: 1.5 }}
                  >
                    <ShareRoundedIcon
                      sx={{
                        fontSize: 19,
                        color: "#11334b",
                      }}
                    />

                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 800,
                        color: "#11334b",
                      }}
                    >
                      Udostępnij odznakę
                    </Typography>
                  </Stack>

                  <Stack direction="row" spacing={1}>
                    <FacebookShareButton
                      hashtag={"#Micree-open-badge"}
                      url={`${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`}
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            "rgba(9,101,254,0.08)",
                          transition: "0.2s",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            backgroundColor:
                              "rgba(9,101,254,0.15)",
                          },
                        }}
                      >
                        <FacebookIcon
                          sx={{ color: "#0965fe" }}
                        />
                      </Box>
                    </FacebookShareButton>

                    <TwitterShareButton
                      hashtag={"#Micree"}
                      url={`${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`}
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            "rgba(0,0,0,0.06)",
                          transition: "0.2s",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            backgroundColor:
                              "rgba(0,0,0,0.12)",
                          },
                        }}
                      >
                        <XIcon sx={{ color: "#000" }} />
                      </Box>
                    </TwitterShareButton>


                    <Box
                      ref={teamsShareRef}
                      className="teams-share-button"
                      data-icon-px-size="25"
                      sx={{
                        width: 44,
                        height: 44,
                        margin: "14px",
                        borderRadius: "12px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",

                        "& button": {
                          width: "44px !important",
                          height: "44px !important",
                          padding: "0 !important",
                          margin: "0 !important",
                          border: "0 !important",
                          background: "transparent !important",
                          cursor: "pointer",
                        },

                        "&:hover": {
                          transform: "translateY(-3px)",
                          backgroundColor: "rgba(98, 100, 167, 0.16)",
                        },

                        transition: "all 0.2s ease",
                        backgroundColor: "rgba(98, 100, 167, 0.08)",
                      }}
                    />

                    <LinkedinShareButton
                      url={`${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`}
                      title={`Mikropoświadczenie z tematu "${badge.attributes.badgeName}"`}
                      summary="Niezmiernie miło jest mi poinformować o zdobyciu nowej odznaki kompetencji w moim portfolio - mikropoświadczenia! Cieszę się, że mogę podzielić się nowym osiągnięciem i kolejnym krokiem w rozwoju zawodowym."
                      source="Micree"
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            "rgba(2,119,181,0.08)",
                          transition: "0.2s",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            backgroundColor:
                              "rgba(2,119,181,0.15)",
                          },
                        }}
                      >
                        <LinkedInIcon
                          sx={{ color: "#0277b5" }}
                        />
                      </Box>
                    </LinkedinShareButton>

                    <EmailShareButton
                      hashtag={"#Micree"}
                      url={`${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`}
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            "rgba(127,127,127,0.08)",
                          transition: "0.2s",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            backgroundColor:
                              "rgba(127,127,127,0.15)",
                          },
                        }}
                      >
                        <EmailIcon
                          sx={{ color: "#7f7f7f" }}
                        />
                      </Box>
                    </EmailShareButton>
                  </Stack>
                </Box>
              </Grid>
            </Grid>


            {badgeSets.length > 0 && (
              <Box
                sx={{
                  p: {
                    xs: 3,
                    md: 5,
                  },
                  borderTop:
                    "1px solid rgba(17,51,75,0.08)",
                  backgroundColor: "#fafcfd",
                }}
              >
                <Typography
                  variant="overline"
                  sx={{
                    color: "#16809a",
                    fontWeight: 800,
                    letterSpacing: "0.12em",
                  }}
                >
                  POWIĄZANE ODZNAKI
                </Typography>

                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 1 }}
                >
                  {badgeSets.map((set, i) => (
                    <Grid
                      key={i}
                      item
                      xs={6}
                      sm={4}
                      md={3}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          height: "100%",
                          p: 2,
                          textAlign: "center",
                          borderRadius: 3,
                          backgroundColor: "#fff",
                          border:
                            "1px solid rgba(17,51,75,0.07)",
                          transition:
                            "transform .2s, box-shadow .2s",
                          "&:hover": {
                            transform:
                              "translateY(-4px)",
                            boxShadow:
                              "0 12px 30px rgba(17,51,75,0.10)",
                          },
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            minHeight: 39,
                            fontWeight: 700,
                            color: "#11334b",
                          }}
                        >
                          {CutText(
                            set.attributes.badgeName,
                            7
                          )}
                        </Typography>

                        <Box
                          sx={{
                            mt: 1,
                            height: 130,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={
                              set.attributes.image.data
                                ?.attributes.url
                            }
                            alt="badge"
                            style={{
                              width: "75%",
                              maxHeight: "120px",
                              objectFit: "contain",
                            }}
                          />
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Paper>
        </Container>
      </Box>

      <Footer />
    </>
  );
}



// import React, { useEffect, useState } from "react";
// import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
// import { Footer } from "../../Components/Footer";
// import {
//   Box,
//   Button,
//   Chip,
//   Container,
//   Grid,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Modal,
//   Paper,
//   Stack,
//   Typography,
//   styled,
// } from "@mui/material";
// import { Link, useParams } from "react-router-dom";
// import { getBadges } from "../../Slices/badges";
// import { useDispatch, useSelector } from "react-redux";
// import { createSelector } from "reselect";
// import axios from "axios";
// import ValidateBadge from "../../Components/validateBadge";
// import moment from "moment";
// import {
//   EmailShareButton,
//   FacebookShareButton,
//   InstapaperShareButton,
//   LinkedinShareButton,
//   PinterestShareButton,
//   RedditShareButton,
//   TwitterShareButton,
//   ViberShareButton,
//   WhatsappShareButton,
// } from "react-share";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import EmailIcon from "@mui/icons-material/Email";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import XIcon from "@mui/icons-material/X";
// import LinkZoneWithCopyButton from "../../Components/CopyLinkButton";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// // import AnalyzeWithAi from "../../Components/AnalyzeWithAi";

// export default function SingleBadge() {
//   useDocumentTitle("Odznaka ");
//   let { badgeId } = useParams();
//   const dispatch = useDispatch();
//   const { user } = useSelector((state) => state.auth);
//   const [show, setShow] = useState(false);

//   const handleClose = () => {
//     setShow(false);
//   };

//   // const handleShow = () => setShow(true);

//   useEffect(() => {
//     dispatch(getBadges({ email: user.email, user: user.jwt }));
//   }, [dispatch, user.email, user.jwt]);

//   const selectBadge = createSelector(
//     (state) => state.badges,
//     (badges) => badges.filter((badge) => badge.id === Number(badgeId))[0]
//   );
//   const badge = useSelector(selectBadge);

//   console.log('badge', badge)

//   const CutText = (text, maxWords) => {
//     const words = text.split(" ");

//     if (words.length <= maxWords) {
//       return text;
//     } else {
//       const truncatedWords = words.slice(0, maxWords);
//       return truncatedWords.join(" ") + "...";
//     }
//   };

//   // const downloadMicrocredential = (url) => {
//   //   const imageURL = url;
//   //   console.log("url", url);
//   //   axios
//   //     .get(imageURL)
//   //     .then((res) => console.log(res))
//   //     .then((response) => response.blob())
//   //     .then((blob) => {
//   //       const url = window.URL.createObjectURL(new Blob([blob]));
//   //       const link = document.createElement("a");
//   //       link.href = url;
//   //       link.setAttribute("download", "odznaka_vcc.jpg");
//   //       document.body.appendChild(link);
//   //       link.click();
//   //       link.parentNode.removeChild(link);
//   //     })
//   //     .catch((error) => console.error("Error downloading image:", error));
//   // };

//   // const verifyMicrocredential = () => {};

//   return (
//     <>
//       {badge && (
//         <Container>
//           <Grid item xs={12}>
//             <Grid container spacing={0}>
//               <Grid item xs={12}>
//                 <Typography
//                   component="h1"
//                   variant="h4"
//                   align="center"
//                   color="text.primary"
//                   sx={{ marginY: "40px" }}
//                 >
//                   {badge.attributes.badgeName}
//                 </Typography>
//               </Grid>

//               <Grid container spacing={8}>
//                 <Grid item xs={12} md={5} sx={{ textAlign: "center" }}>
//                   <img
//                     // src={`${process.env.REACT_APP_STRAPI_MEDIA}${badge.attributes.image.data.attributes.url}`}
//                     src={badge.attributes.image.data?.attributes.url}
//                     alt="badge"
//                     style={{ width: "90%", marginTop: "20px" }}
//                   />

//                   <Grid container sx={{ marginTop: "50px" }}>
//                     {badge.attributes.badge_model_reference.data?.attributes.sets.data.map(
//                       (set, i) => (
//                         <Grid
//                           key={i}
//                           item
//                           xs={6}
//                           sx={{ textAlign: "center", mb: 3 }}
//                         >
//                           <Typography
//                             component="h4"
//                             variant="caption"
//                             align="center"
//                             color="text.primary"
//                             minHeight={39}
//                           >
//                             {CutText(set.attributes.badgeName, 7)}
//                           </Typography>
//                           <img
//                             // src={`${process.env.REACT_APP_MEDIA_URL}${set.attributes.image?.data.attributes.url}`}
//                             src={set.attributes.image.data?.attributes.url}
//                             alt="badge"
//                             style={{ width: "60%", marginTop: "20px" }}
//                           />
//                         </Grid>
//                       )
//                     )}
//                   </Grid>
//                   {/* <Grid container sx={{ marginTop: "50px" }}>
//                     {badge.attributes.sets.data.map((set) => (
//                       <Grid item xs={6} sx={{ textAlign: "center" }}>
//                         <Typography
//                           component="h4"
//                           variant="caption"
//                           align="center"
//                           color="text.primary"
//                         >
//                           {set.attributes.badgeName}
//                         </Typography>
//                         <img
//                           // src={`${process.env.REACT_APP_MEDIA_URL}${set.attributes.image?.data.attributes.url}`}
//                           src={set.attributes.image.data.attributes.url}
//                           alt="badge"
//                           style={{ width: "60%", marginTop: "20px" }}
//                         />
//                       </Grid>
//                     ))}
//                   </Grid> */}
//                 </Grid>
//                 <Grid item xs={12} md={7}>
//                   <Typography
//                     component="h2"
//                     variant="h5"
//                     sx={{ marginBottom: "50px" }}
//                   >
//                     <span style={{ fontWeight: "bold" }}>{badge.desc}</span>
//                   </Typography>
//                   <Box>
//                     <Typography component="h4" variant="subtitle1">
//                       Data wystawienia:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {moment(badge.attributes.issuanceDate).format("LL")}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Data {badge.attributes.szkolenie === true ? "ukończenia szkolenia" : "egzaminu"}:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.exam_expiry_date
//                           ? moment(badge.attributes.exam_expiry_date).format(
//                             "LL"
//                           )
//                           : ""}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Data wygaśnięcia:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.expirationDate
//                           ? moment(badge.attributes.expirationDate).format("LL")
//                           : "bezterminowo"}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Instytucja wystawiająca: {<b>Fundacja VCC</b>}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.issuer}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Kraj wystawcy: {<b>Polska</b>}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.issuer}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Rodzaj odznaki:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.badgeType}
//                       </span>
//                     </Typography>
//                     {badge?.qualificationName &&
//                       <Typography component="h4" variant="subtitle1">
//                         Kwalifikacja:{" "}
//                         <span style={{ fontWeight: "bold" }}>
//                           {badge?.attributes.qualificationName}
//                         </span>
//                       </Typography>
//                     }
//                   </Box>
//                   <Box sx={{ marginTop: "40px" }}>
//                     <Typography component="h4" variant="subtitle1">
//                       EFEKTY UCZENIA SIĘ:
//                       <List>
//                         {badge.attributes.learningEffects?.learningEffects.map(
//                           (item, i) => (
//                             <ListItem key={i} sx={{ padding: 0 }}>
//                               <ListItemIcon>
//                                 <ChevronRightIcon />
//                               </ListItemIcon>
//                               <ListItemText primary={item.effectName} />
//                             </ListItem>
//                           )
//                         )}
//                       </List>
//                     </Typography>
//                   </Box>

//                   <LinkZoneWithCopyButton slug={badge.attributes.slug} />

//                   <a
//                     href={badge.attributes.image.data?.attributes.url}
//                     download
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Button
//                       variant="outlined"
//                       sx={{
//                         mt: 4,
//                         padding: "15px 32px",
//                         backgroundColor: "#ed6c0217",
//                       }}
//                     >
//                       Pobierz mikropoświadczenie
//                     </Button>
//                   </a>


//                   {/* <AnalyzeWithAi
//                     text={badge.attributes.learningEffects?.learningEffects}
//                   /> */}
//                   <Button
//                     variant="outlined"
//                     sx={{
//                       mt: 4,
//                       ml: 2,
//                       padding: "15px 32px",
//                       backgroundColor: "#ed6c0217",
//                     }}
//                     onClick={() => setShow(true)}
//                   >
//                     Weryfikuj
//                   </Button>
//                   <Modal
//                     open={show}
//                     onClose={handleClose}
//                     sx={{
//                       justifyContent: "center",
//                       height: "100vh",
//                       alignContent: "center",
//                     }}
//                   >
//                     <ValidateBadge setShow={setShow} />
//                   </Modal>
//                   <Box sx={{ mt: 4 }}>
//                     <FacebookShareButton
//                       hashtag={"#Micree-open-badge"}
//                       url={`${process.env.REACT_APP_MEDIA_URL}/public-badge/${badge.attributes.slug}`}
//                       // url={`https://apka.vccsystem.eu/public-badge/${badge.attributes.slug}`}
//                       style={{ padding: "14px" }}
//                     >
//                       <FacebookIcon
//                         fontSize="large"
//                         sx={{ color: "#0965fe" }}
//                       />
//                     </FacebookShareButton>
//                     <TwitterShareButton
//                       hashtag={"#Micree"}
//                       url={"https://micree.pl/"}
//                       style={{ padding: "14px" }}
//                     >
//                       <XIcon fontSize="large" sx={{ color: "#000000" }} />
//                     </TwitterShareButton>
//                     <LinkedinShareButton
//                       hashtag={"#Micree"}
//                       style={{ padding: "14px" }}
//                       url={"https://micree.pl/"}
//                     >
//                       <LinkedInIcon
//                         fontSize="large"
//                         sx={{ color: "#0277b5" }}
//                         title={"Badge Micree"}
//                         summary={"opis badga"}
//                         source={"url z badgem"}
//                       />
//                     </LinkedinShareButton>
//                     <EmailShareButton
//                       hashtag={"#Micree"}
//                       style={{ padding: "14px" }}
//                     >
//                       <EmailIcon fontSize="large" sx={{ color: "#7f7f7f" }} />
//                     </EmailShareButton>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Container>
//       )}
//       <Footer />
//     </>
//   );
// }
